import { AuthenticationService } from "../../services/authentication.service";
import { ApiService } from "../../services/api.service";
import { Router } from "@angular/router";
var NavbarComponent = (function () {
    function NavbarComponent(authService, apiService, router) {
        this.authService = authService;
        this.apiService = apiService;
        this.router = router;
        this.username = '';
    }
    NavbarComponent.prototype.ngOnInit = function () {
        var username = localStorage.getItem('username');
        this.username = username;
    };
    NavbarComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    NavbarComponent.prototype.canUserSignDoc = function () {
        return this.authService.isAccountant();
    };
    NavbarComponent.prototype.isAdmin = function () {
        return this.authService.isAdmin();
    };
    NavbarComponent.prototype.isUIH = function () {
        return this.authService.isUIH();
    };
    NavbarComponent.prototype.isAccountant = function () {
        return this.authService.isAccountant();
    };
    NavbarComponent.prototype.isAccountantAdmin = function () {
        return this.authService.isAccountantAdmin();
    };
    NavbarComponent.prototype.isIT = function () {
        return this.authService.isIT();
    };
    NavbarComponent.prototype.isViewer = function () {
        return this.authService.isViewer();
    };
    NavbarComponent.prototype.isViewerAudit = function () {
        return this.authService.isViewerAudit();
    };
    NavbarComponent.prototype.getUsername = function () {
        return localStorage.getItem('username');
    };
    NavbarComponent.prototype.getRole = function () {
        return localStorage.getItem('group');
    };
    NavbarComponent.prototype.isSystemAdmin = function () {
        return this.authService.isSystemAdmin();
    };
    NavbarComponent.prototype.hasViewDocumentRequestPermission = function () {
        return this.authService.hasRequestDeletePermission() || this.authService.hasRequestEditPermission();
    };
    NavbarComponent.prototype.logout = function () {
        var _this = this;
        this.apiService.logout().subscribe(function () {
            _this.router.navigate(['/login']);
        });
        this.sniff('LOGOUT', this.username);
    };
    NavbarComponent.prototype.sniff = function (action, detail) {
        var data = {
            action: action,
            feature: 'HOME',
            detail: detail
        };
        this.apiService.sniff(data).subscribe();
    };
    return NavbarComponent;
}());
export { NavbarComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/core/navbar/navbar.component.ts.pre-build-optimizer.js